import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
        <code>sudo-self</code>
        </p>
        <a
          className="App-link"
          href="https://sudo-self.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          sudo-self.com
        </a>
      </header>
    </div>
  );
}

export default App;
